// extracted by mini-css-extract-plugin
export default {"date":"document-metadata_date__1OMXW","items":"document-metadata_items__22-YK","button":"document-metadata_button__36KXb"};